export default function DodgeballIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="2" y="2" width="60" height="60" rx="14" fill="#D9984F" />
      <path d="M2 18h60M2 32h60M2 46h60" stroke="#B87638" strokeWidth="1.5" />
      <rect x="2" y="2" width="30" height="60" rx="14" fill="#2F8BFF" fillOpacity="0.25" />
      <rect x="32" y="2" width="30" height="60" rx="14" fill="#FF8A1F" fillOpacity="0.25" />
      <path d="M32 4v56" stroke="#FFFFFF" strokeWidth="4" />
      <path d="M6 24h12M4 33h14M8 42h10" stroke="#FFFFFF" strokeWidth="3.5" strokeLinecap="round" strokeOpacity="0.9" />
      <circle cx="37" cy="33" r="16" fill="#F0384F" stroke="#7A1020" strokeWidth="2.5" />
      <path d="M30 18.5c6 4 8 10 7 29" stroke="#FFF0C8" strokeWidth="3" fill="none" strokeLinecap="round" />
      <ellipse cx="31" cy="26" rx="4.5" ry="2.8" fill="#FFFFFF" fillOpacity="0.6" transform="rotate(-35 31 26)" />
      <path d="M54 10l2 5 5 1-4 3 1 5-4-3-4 3 1-5-4-3 5-1z" fill="#FFE14D" stroke="#7A5A10" strokeWidth="1" />
    </svg>
  );
}
